import React from "react";
import classes from "./ActionButtonStyles.module.scss";
import cx from "classnames";

type Props = {
  buttonText: string | JSX.Element;
  onClick: () => void;
  className?: string;
  type: "grey" | "outlined" | "black";
  disabled?: boolean;
};
export const ActionButton = ({ buttonText, className, onClick, type, disabled }: Props) => {
  const getComponentStyles = () => {
    switch (type) {
      case "grey":
        return classes.greyComponent;
      case "outlined":
        return classes.outlinedComponent;
      case "black":
        return classes.blackComponent;
    }
  };
  const styles = getComponentStyles();
  return (
    <button disabled={disabled} className={cx(classes.component, styles, className || "")} onClick={onClick}>
      {buttonText}
    </button>
  );
};
